
import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { SmartInput } from './SmartInput';

interface AudioVolumeSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const AudioVolumeSection: React.FC<AudioVolumeSectionProps> = ({ config, setConfig }) => {
  return (
    <div className="flex flex-col gap-3 p-4 rounded-3xl border bg-blue-500/5 border-blue-500/20">
      <SectionLabel icon="fa-volume-high" darkMode={config.darkMode}>Volume Mixer</SectionLabel>
      
      <div className="flex flex-col gap-2">
        <SmartInput 
          label="Master Volume" 
          min={0} 
          max={2} 
          step={0.01} 
          value={config.masterVolume} 
          onChange={v => setConfig(p => ({...p, masterVolume: v}))} 
          darkMode={config.darkMode} 
        />
        <SmartInput 
          label="Melody Volume" 
          min={0} 
          max={2} 
          step={0.01} 
          value={config.melodyVolume} 
          onChange={v => setConfig(p => ({...p, melodyVolume: v}))} 
          darkMode={config.darkMode} 
        />
        <SmartInput 
          label="Collision Volume" 
          min={0} 
          max={2} 
          step={0.01} 
          value={config.collisionVolume} 
          onChange={v => setConfig(p => ({...p, collisionVolume: v}))} 
          darkMode={config.darkMode} 
        />
      </div>
    </div>
  );
};
